import Vue from 'vue';
import Router from 'vue-router';
import carousel from 'vue-owl-carousel';
Vue.component('owl-carousel', carousel);
import { Skeleton } from 'vue-loading-skeleton';

/**
 * Skeleton
 */

Vue.component('skeleton', Skeleton);
/**
 * Page Helpers
 */
import Spinner from '@/Components/Pages/Helpers/Spinner.vue';
import Loading from '@/Components/Pages/Helpers/Loading.vue';

/**
 * Pages
 */
import Page404 from '@/Components/Pages/404.vue';
import HomePage from '@/Components/Pages/Homepage.vue';
import VisitorAgeVerification from '@/Components/Pages/VisitorAgeVerification.vue';
import EmailVerification from '@/Components/Pages/EmailVerification.vue';

import LoginWithToken from '@/Components/Pages/LoginWithToken.vue'; // different custom tokens
import LoginWithUserAuthToken from '@/Components/Pages/LoginWithUserAuthToken.vue'; // bearer token 

import SignUpAuthenticate from '@/Components/Pages/SignUpAuthenticate.vue';
import AddAnonymous from '@/Components/Pages/AddAnonymous.vue';

/**
 * Product pages
 */
// import RecommendProductDetail from '@/Components/Pages/RecommendProductDetail.vue';
import LocationProductDetail from '@/Components/Pages/LocationProductDetail.vue';
import LocationProductDetailNew from '@/Components/Pages/LocationProductDetailNew.vue';
// import ProductReview from '@/Components/Pages/ProductReview.vue';
// import ProductWriteReview from '@/Components/Pages/ProductWriteReview.vue';
import Cart from '@/Components/Pages/Cart.vue';
import Checkout from '@/Components/Pages/Checkout.vue';
import CartSuccess from '@/Components/Pages/CartSuccess.vue';

/**
 * Register Page
 */
 import Register from '@/Components/Pages/Register.vue';

/**
 * Search pages
 */
import SearchProductResult from '@/Components/Pages/SearchProductResult.vue';

/**
 * Budtender update verification
 */
 import EmailPhoneUpdateVerification from '@/Components/Pages/EmailPhoneUpdateVerification.vue';

/**
 * Store Pages
 */
import StoreProfile from '@/Components/Pages/StoreProfile.vue';
import StoreLanding from '@/Components/Pages/StoreLanding.vue';
// import StoreReviews from '@/Components/Pages/StoreReviews.vue';
// import StoreWriteReview from '@/Components/Pages/StoreWriteReview.vue';
import StoreLocations from '@/Components/Pages/StoreLocations.vue';


/**
 * Normal Pages
 */
import PrivacyPolicy from '@/Components/Pages/PrivacyPolicy.vue';
import TermsConditions from '@/Components/Pages/TermsConditions.vue';
//import HelpSupport from '@/Components/Pages/HelpSupport.vue';
import HelpAndSupport from '@/Components/Pages/HelpAndSupport.vue';
import Faqs from '@/Components/Pages/Faqs.vue';

/**
 * Verification
 */
// import EmailVerified from '@/Components/Pages/EmailVerified.vue';


/**
 * Logged in routes
 */
import UserEditAccount from '@/Components/Pages/User/UserEditAccount.vue';
import UserAccountMembership from '@/Components/Pages/User/Membership.vue';

import UserFavouriteProducts from '@/Components/Pages/User/UserFavouriteProducts.vue';
import UserFavouriteProductDetail from '@/Components/Pages/User/UserFavouriteProductDetail.vue';
import UserFavouriteStores from '@/Components/Pages/User/UserFavouriteStores.vue';
// import AddYourStore from '@/Components/Pages/User/AddYourStore.vue';

/**
 * Orders
 */
import UserOrderHistory from '@/Components/Pages/User/OrderHistory.vue';
import UserOrderStatus from '@/Components/Pages/User/OrderStatus.vue';

/**
 * Notifications
 */
import UserNotifications from '@/Components/Pages/User/Notifications.vue';
import UserSurvey from '@/Components/Pages/User/Survey.vue';

/**
 * Middlewares
 */
import NoAuth from '@/Components/Middlewares/noAuth';
import Auth from '@/Components/Middlewares/auth';
import VisitorAgeVerify from '@/Components/Middlewares/visitorAgeVerify';
import RedirectToBasePath from '@/Components/Middlewares/redirectToBasePath';


/**
 * Includes
 */
import AppSkeleton from '@/Components/Pages/Inc/AppSkeleton.vue';
import AppHeader from '@/Components/Pages/Inc/Header.vue';
import AppFooter from '@/Components/Pages/Inc/Footer.vue';
import AppSignUpLoginOptionModal from '@/Components/Pages/Inc/SignUpLoginOptionModal.vue';
import AppLoginModal from '@/Components/Pages/Inc/LoginModal.vue';
import AppSignUpModal from '@/Components/Pages/Inc/SignUpModal.vue';
import AppVerifiedEmailModal from '@/Components/Pages/Inc/VerifiedEmailModal.vue';
import AppResetPasswordModal from '@/Components/Pages/Inc/ResetPasswordModal.vue';
import AppSetLocationModal from '@/Components/Pages/Inc/SetLocationModal.vue';
import AppSignOut from '@/Components/Pages/Inc/SignOutModal.vue';
import AppSnackbar from '@/Components/Pages/Inc/Snackbar.vue';
// import AppOrderNotificationSnackbar from '@/Components/Pages/Inc/OrderNotificationSnackbar.vue';
import EmailVerifiedNotice from '@/Components/Pages/Inc/EmailVerifiedNotice.vue';
import SetPasswordNotice from '@/Components/Pages/Inc/SetPasswordNotice.vue';
// import LoyalitySignup from '@/Components/Pages/Inc/LoyalitySignup.vue';
import LoyalitySignupCongratulations from '@/Components/Pages/Inc/LoyalitySignupCongratulations.vue';
import LoyalityReferralCongratulations from '@/Components/Pages/Inc/LoyalityReferralCongratulations.vue';
import LoyalityCheckInCongratulations from '@/Components/Pages/Inc/LoyalityCheckInCongratulations.vue';
import InStoreModal from '@/Components/Pages/Inc/InStoreModal.vue';

// App cart
import AppCart from '@/Components/Pages/PageComponents/Cart/CartSidebar.vue';
import AppCartItemAddedRecommendProducts from '@/Components/Pages/PageComponents/Cart/CartRecommendProducts.vue';

// Cards
import WeedCard from "@/Components/Pages/PageComponents/StoreProfile/WeedCard";
import WeedCardList from "@/Components/Pages/PageComponents/StoreProfile/WeedCardList";
import AccessoryCard from "@/Components/Pages/PageComponents/StoreProfile/AccessoryCard";
import AccessoryCardList from "@/Components/Pages/PageComponents/StoreProfile/AccessoryCardList";

// Fiska response
import FiskaResponse from "@/Components/Pages/FiskaResponse.vue";
import CloverResponse from "@/Components/Pages/CloverResponse.vue";

Vue.component('app-skeleton', AppSkeleton);
Vue.component('app-spinner', Spinner);
Vue.component('app-header', AppHeader);
Vue.component('app-footer', AppFooter);
Vue.component('app-signup-login-option-modal', AppSignUpLoginOptionModal);
Vue.component('app-login-modal', AppLoginModal);
Vue.component('app-signup-modal', AppSignUpModal);
Vue.component('app-verifiedemail-modal', AppVerifiedEmailModal);
Vue.component('app-resetpassword-modal', AppResetPasswordModal); // reset password form if tokenb valid
Vue.component('app-setlocation-modal', AppSetLocationModal);
Vue.component('app-sign-out', AppSignOut);
Vue.component('app-snackbar', AppSnackbar);
Vue.component('app-sidebar-cart', AppCart);
Vue.component('added-to-cart-recommend-products', AppCartItemAddedRecommendProducts);
Vue.component('loading', Loading);
// Vue.component('order-notification-snackbar', AppOrderNotificationSnackbar);
Vue.component('email-verified-notice', EmailVerifiedNotice);
Vue.component('set-password-notice', SetPasswordNotice);
// Vue.component('loyality-signup', LoyalitySignup);
Vue.component('loyality-signup-congratulations', LoyalitySignupCongratulations);
Vue.component('loyality-referral-congratulations', LoyalityReferralCongratulations);
Vue.component('loyality-checkin-congratulations', LoyalityCheckInCongratulations);
Vue.component('in-store', InStoreModal);
Vue.component('weed-card', WeedCard);
Vue.component('weed-card-list', WeedCardList);
Vue.component('accessory-card', AccessoryCard);
Vue.component('accessory-card-list', AccessoryCardList);

const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
};
Vue.use(Router);
export default new Router({
    mode: 'history',
    routes: [
        { 
          path: '/', 
          //redirect: `/${Env.defaultBusinessSlug}`  
          meta: {
            middleware: [RedirectToBasePath],
          },
        },
        {
          path: '/fiska-response',
          addtoNav: false,
          name: 'FiskaResponse',
          component: FiskaResponse,
        },
        {
          path: '/clover-response',
          addtoNav: false,
          name: 'CloverResponse',
          component: CloverResponse,
        },
        {
          path: '/404',
          addtoNav: false,
          name: 'PageNotFound',
          component: Page404,
        },
        /**
         * Normal routes
         */
        {
            path: '/:business_slug',
            component: HomePage,
            name: 'HomePage',
            addtoNav: false,
            navText: 'Homepage',
            meta: {
                middleware: [VisitorAgeVerify],
            },
        },
        {
            path: '/:business_slug/verify-age',
            component: VisitorAgeVerification,
            name: 'VisitorAgeVerification',
            addtoNav: false,
            navText: 'VisitorAgeVerification',
            meta: {
                middleware: '',
            },
        },
        {
            path: '/:business_slug/email-verify',
            component: EmailVerification,
            name: 'EmailVerification',
            addtoNav: false,
            navText: 'EmailVerification',
            meta: {
                middleware: '',
            },
        },

         /**
         * Login With token
         */ 
        {
          path: '/:business_slug/:locationId/GuestLog', // url ?token=token&hide-map-true
          component: LoginWithToken,
          name: 'LoginWithToken',
          addtoNav: false,
          navText: 'LoginWithToken',
          meta: {
            middleware: '',
          },
        },

         /**
         * Login With user auth token not like top one
         */ 
          {
            path: '/:business_slug/:store_slug/user-login', // url ?token=token&hide-map-true
            component: LoginWithUserAuthToken,
            name: 'LoginWithUserAuthToken',
            addtoNav: false,
            navText: 'LoginWithUserAuthToken',
            meta: {
              // middleware: [NoAuth],
            },
          },
        /**
         * Signup auto login with token
         */
        {
          path: '/:business_slug/signup-authneticate', // url ?token=token
          component: SignUpAuthenticate,
          name: 'SignUpAuthenticate',
          addtoNav: false,
          navText: 'SignUpAuthenticate',
          meta: {
            middleware: '',
          },
        },

        {
          path: '/:business_slug/register', // url ?token=token&hide-map-true
          component: Register,
          name: 'Register',
          addtoNav: false,
          navText: 'Register',
          meta: {
            middleware: [NoAuth],
          },
        },

        /**
         * Add  anonymous
         */ 
        {
          path: '/:business_slug/:store_slug/add_anonymous', 
          component: AddAnonymous,
          name: 'AddAnonymous',
          addtoNav: false,
          navText: 'AddAnonymous',
          meta: {
            middleware: '',
          },
        },

        /**
         * Store page
         */
        {
            path: '/:business_slug/stores',
            component: StoreLocations,
            name: 'StoreLocations',
            addtoNav: false,
            navText: 'StoreLocations',
            meta: {
                middleware: [VisitorAgeVerify],
            },
        },

        /**
         * Default / Normal pages static route
         */
        {
          path: '/:business_slug/privacy-policy',
          component: PrivacyPolicy,
          name: 'PrivacyPolicy',
          addtoNav: false,
          navText: 'PrivacyPolicy',
          meta: {
              // middleware: [VisitorAgeVerify],
          },
        },
        
        {
          path: '/:business_slug/support',
          component: HelpAndSupport,
          name: 'HelpAndSupport',
          addtoNav: false,
          navText: 'Help And Support',
          meta: {
              middleware: [VisitorAgeVerify],
          },
        },
        {
          path: '/:business_slug/faqs',
          component: Faqs,
          name: 'Faqs',
          addtoNav: false,
          navText: 'Faqs',
          meta: {
              middleware: [VisitorAgeVerify],
          },
        },
        {
          path: '/:business_slug/terms-conditions',
          component: TermsConditions,
          name: 'TermsConditions',
          addtoNav: false,
          navText: 'TermsConditions',
          meta: {
              // middleware: [VisitorAgeVerify],
          },
        },
       
        // {
        //     path: '/:business_slug/email-verified',
        //     component: EmailVerified,
        //     name: 'EmailVerified',
        //     addtoNav: false,
        //     navText: 'EmailVerified',
        //     meta: {
        //         middleware: [VisitorAgeVerify, Auth],
        //     },
        // },

        /**
         * Logged in routes
         */
        {
            path: '/:business_slug/user/edit-account',
            component: UserEditAccount,
            name: 'UserEditAccount',
            addtoNav: false,
            navText: 'UserEditAccount',
            meta: {
              middleware: [VisitorAgeVerify, Auth],
            },
        },
        {
          path: '/:business_slug/user/membership',
          component: UserAccountMembership,
          name: 'UserAccountMembership',
          addtoNav: false,
          navText: 'UserAccountMembership',
          meta: {
            middleware: [VisitorAgeVerify, Auth],
          },
        },


        {
            path: '/:business_slug/user/:store_slug/favourite-products',
            component: UserFavouriteProducts,
            name: 'UserFavouriteProducts',
            addtoNav: false,
            navText: 'UserFavouriteProducts',
            meta: {
              middleware: [VisitorAgeVerify, Auth],
            },
        },

        {
            path: '/:business_slug/user/:store_slug/favourite-stores',
            component: UserFavouriteStores,
            name: 'UserFavouriteStores',
            addtoNav: false,
            navText: 'UserFavouriteStores',
            meta: {
              middleware: [VisitorAgeVerify, Auth],
            },
        },


        {
            path: '/:business_slug/user/favourite-products/:id',
            component: UserFavouriteProductDetail,
            name: 'UserFavouriteProductDetail',
            addtoNav: false,
            navText: 'UserFavouriteProductDetail',
            meta: {
              middleware: [VisitorAgeVerify, Auth],
            },
        },

        /**
         * User orders
         */
        {
            path: '/:business_slug/user/order-history',
            component: UserOrderHistory,
            name: 'UserOrderHistory',
            addtoNav: false,
            navText: 'UserOrderHistory',
            meta: {
              middleware: [VisitorAgeVerify, Auth],
            },
        },

        {
            path: '/:business_slug/user/order-status',
            component: UserOrderStatus,
            name: 'UserOrderStatus',
            addtoNav: false,
            navText: 'UserOrderStatus',
            meta: {
              middleware: [VisitorAgeVerify, Auth],
            },
        },

        /**
         * Notifications
         */
        // {
        //     path: '/:business_slug/user/notifications',
        //     component: UserNotifications,
        //     name: 'UserNotifications',
        //     addtoNav: false,
        //     navText: 'UserNotifications',
        //     meta: {
        //       middleware: [VisitorAgeVerify, Auth],
        //     },
        // },
        // {
        //     path: '/:business_slug/user/survey',
        //     component: UserSurvey,
        //     name: 'UserSurvey',
        //     addtoNav: false,
        //     navText: 'UserSurvey',
        //     meta: {
        //       middleware: [VisitorAgeVerify, Auth],
        //     },
        // },

        /**
         * ================
         *  Dynamic routes with params
         * =============
         */


        // {
        //     path: '/product/:product_id/review',
        //     component: ProductReview,
        //     name: 'ProductReview',
        //     addtoNav: false,
        //     navText: 'ProductReview',
        //     meta: {
        //         middleware: [VisitorAgeVerify],
        //     },
        // },


        // {
        //     path: '/product/:product_id/write-review',
        //     component: ProductWriteReview,
        //     name: 'ProductWriteReview',
        //     addtoNav: false,
        //     navText: 'ProductWriteReview',
        //     meta: {
        //         middleware: [VisitorAgeVerify],
        //     },
        // },


        /**
         * Dynamic store params routes
         */
        {
          path: '/:business_slug/:store_slug',
          component: StoreLanding,
          name: 'StoreLanding',
          addtoNav: false,
          navText: 'StoreLanding',
          meta: {
              middleware: [VisitorAgeVerify],
          },
        },
        {
            path: '/:business_slug/:store_slug/shop',
            component: StoreProfile,
            name: 'StoreProfile',
            addtoNav: false,
            navText: 'StoreProfile',
            meta: {
                middleware: [VisitorAgeVerify],
            },
        },
        {
          path: '/:business_slug/:store_slug/search-product',
          component: SearchProductResult,
          name: 'SearchProductResult',
          addtoNav: false,
          navText: 'SearchProductResult',
          meta: {
              middleware: [VisitorAgeVerify],
          },
        },
        {
          path: '/:business_slug/:store_slug/account-update-verification',
          component: EmailPhoneUpdateVerification,
          name: 'EmailPhoneUpdateVerification',
          addtoNav: false,
          navText: 'EmailPhoneUpdateVerification',
          meta: {
              middleware: [VisitorAgeVerify],
          },
        },

        // {
        //     path: '/store/:store_slug/reviews',
        //     component: StoreReviews,
        //     name: 'StoreReviews',
        //     addtoNav: false,
        //     navText: 'StoreReviews',
        //     meta: {
        //         middleware: [VisitorAgeVerify],
        //     },
        // },
        // {
        //     path: '/:store_slug/write-review',
        //     component: StoreWriteReview,
        //     name: 'StoreWriteReview',
        //     addtoNav: false,
        //     navText: 'StoreWriteReview',
        //     meta: {
        //         middleware: [VisitorAgeVerify],
        //     },
        // },

        {
            path: '/:business_slug/:store_slug/cart',
            component: Cart,
            name: 'Cart',
            addtoNav: false,
            navText: 'Cart',
            meta: {
                middleware: [VisitorAgeVerify],
            },
        },
        {
          path: '/:business_slug/:store_slug/checkout',
          component: Checkout,
          name: 'Checkout',
          addtoNav: false,
          navText: 'Checkout',
          meta: {
              middleware: [VisitorAgeVerify],
          },
        },

        {
          path: '/:business_slug/:store_slug/cart/success',
          component: CartSuccess,
          name: 'CartSuccess',
          addtoNav: false,
          navText: 'Cart Success',
          meta: {
              middleware: [VisitorAgeVerify],
          },
      },

        /**
         * Dynamic product route
         */
        {
            path: '/:business_slug/:store_slug/:product_id',
            component: LocationProductDetailNew,
            name: 'LocationProductDetail',
            addtoNav: false,
            navText: 'LocationProductDetail',
            meta: {
                middleware: [VisitorAgeVerify],
            },
        },
        // {
        //   path: '/:business_slug/:store_slug/new/:product_id',
        //   component: LocationProductDetailNew,
        //   name: 'LocationProductDetailNew',
        //   addtoNav: false,
        //   navText: 'LocationProductDetailNew',
        //   meta: {
        //       middleware: [VisitorAgeVerify],
        //   },
        // },
       
        {
            path: '*',
            addtoNav: false,
            name: '404',
            component: Page404,
        },
        
    ],

});